import { getCsrfValue } from "~/api/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export function apiUpdateColumnSettings(
  columnConfiguration: { code: string; visible: boolean }[],
  resetPosition = false,
): Promise<Response> {
  const body = {
    columnPreferences: {
      showVisibilityUpdate: {
        codes: columnConfiguration.filter((item) => item.visible).map((item) => item.code),
      },
      hideVisibilityUpdate: {
        codes: columnConfiguration.filter((item) => !item.visible).map((item) => item.code),
      },
      positionUpdate: columnConfiguration.map((item, index) => ({
        code: item.code,
        position: resetPosition ? undefined : index,
      })),
    },
  };

  const url = resolveApiUrl("/search/updatePreferences");

  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    body: JSON.stringify(body),
  });
}
